import { HackleUser } from "../../model/model"
import { WorkspaceMetadata } from "../Workspace"
import WorkspaceEvaluation from "./WorkspaceEvaluation"
import WorkspaceEvaluationFetcher from "./WorkspaceEvaluationFetcher"

/**
 * A no-op workspace evaluation fetcher. Used in local evaluation mode, where there is no
 * server-resolved evaluation; callers fall back to their defaults.
 */
export class NoopWorkspaceEvaluationFetcher implements WorkspaceEvaluationFetcher {
  metadata(): WorkspaceMetadata | null {
    return null
  }

  workspace(_user: HackleUser): WorkspaceEvaluation | null {
    return null
  }
}
